const { validateUUID, validateUrl } = require("../validator");
const { MundipaggCard } = require("./card.mundippag");
const { StripeCard } = require("./card.stripe");
const { GetToken } = require("../token/token")

class CardHandler {
  constructor(params) {
    this.getTokenData = new GetToken(params);
    this.tokenData = this.getTokenData.get()
  }
  handler(params) {
    return new Promise((resolve, reject) => {
      this.tokenData.then(response => {
        let handleAction = null;
        const { status, data } = response;
        if (status === 200) {
          handleAction = _handleAction({ data, params })
          if (handleAction instanceof Error) {
            reject(handleAction)
          }
          resolve(handleAction)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

function _handleAction({ data, params }) {
  if (data.gateway === 'mundipagg') {
    const hasError = handleError({ data, params });
    if (hasError) return new Error(hasError);
    const payload = {
      personId: params.personId,
      baseUrl: params.baseUrl,
      gatewayUrl: data.gatewayUrl,
      accessToken: params.accessToken,
      token: data.token,
    }
    return new MundipaggCard(payload);
  }
}

function handleError({ data, params }) {
  let msg = "", txt = "";
  if (!validateUrl(params.baseUrl)) {
    txt = "baseUrl is not valid or not provide. \n";
    msg += txt;
  }
  if (!data.gatewayUrl) {
    txt = "gatewayUrl from getToken is not valid or not provide. \n";
    msg += txt;
  }
  if (!data.token) {
    txt = "code from getToken is not provide. \n";
    msg += txt;
  }
  return msg;
}

module.exports = CardHandler;
